<template>
  <span class="badge badge-purple mr-1">
    <i class="fas fa-filter mr-1"></i>
      {{ content }}
    <i class="fas fa-window-close ml-1 cursor-pointer" @click="clear"></i>
  </span>
</template>

<script>
export default {
  props: {
    item: Object,
  },

  computed: {
    /**
     * @return {string}
     */
    content() {
      return this.item.content;
    },
  },

  methods: {
    /**
     * @emits clear
     */
    clear() {
      this.$emit('clear', this.item);
    },
  },
}
</script>
